$ = require 'jquery'

Main = require './main'
Boxes = require './boxes'
Scroll = require './scroll'
#Contact = require './contact'


module.exports = 
	$(document).ready ->
		console.log 'doc ready'